import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { COMPLETE } from '../../../components/body/survey/question.js';

import imgThankYou from '../../../units/img/thankyouGirl.gif'

function ThankPage() {
    const { language, idBranch } = useParams();
    const [seconds, setSeconds] = useState(5);

    useEffect(() => {
      if (seconds > 0 && idBranch) {
        const timer = setTimeout(() => setSeconds(seconds - 1), 1000);
        return () => clearTimeout(timer);
      }
    }, [seconds]);

    return (<div style={{ textAlign:'center' , padding: '65px' }}>  
        <div>-----------</div>
        <div style={{fontSize:'1.2rem', fontWeight:"600"}}>{!language ? COMPLETE["eng"] : COMPLETE[language]}</div>
        <img src={imgThankYou} 
             alt="thankyou"
             onClick={idBranch ? ()=>window.open("/","_self") : ""}
        />
        <div>-----------</div>
        {
          idBranch && <div>
          {seconds === 0 ? window.open("/","_self")
          : (
            <div style={{fontSize:'1.2rem', fontWeight:"600"}}>
              {seconds + (
                language === "jap" ? "秒でホームペーリに戻ります。" :
                language === "vie" ? " giây quay lại trang chủ" :
                language === "kor" ? "초 후 홈페이지로 돌아갑니다." :
                language === "chn" ? "秒后返回主页。" :
                " seconds go to home"
              )}
            </div>
          )}
        </div> 
        }
    </div>)
}

export default ThankPage;
